<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <h2>Applying Risk Measures in Your Everyday Life</h2>
          
  <p>
    🌟 Embark on a purr-sonal finance adventure with RiskyPaws, where every stage of your life unfolds a new chapter of risk and reward. As a frisky kitten, learn the ropes of financial play with simple tools like budget trackers and savings calculators. They're the yarn balls and feather wands that teach you the basics of fiscal balance and the joy of earning your treats. 🐱
  </p>

  
  <p>
    As you leap into the bustling world of adult cats, RiskyPaws grows with you, sharpening your claws on the scratching post of investments and insurance. Navigate the catwalk of life's uncertainties with grace, whether it's choosing the right insurance policy or building an emergency fund for those rainy days when you'd rather just stay indoors and nap. 🌧️🐈
  </p>

  <p>
    Mature into a majestic feline with advanced RiskyPaws strategies, where you'll hunt for long-term prosperity. Here, the game becomes more thrilling with stocks, bonds, and real estate - the big leagues of the financial jungle where the poised and the wise prowl for opportunities. 📈
  </p>
  
  <p>
    In your golden years, bask in the warm sunbeam of security you've built with RiskyPaws. With a treasure trove of wealth management knowledge, live out your days with the serenity of a cat who knows their needs are taken care of. From estate planning to retirement funds, you're as prepared as a cat always lands on its feet. 🌅🐾
  </p>
  
  <p>
    So, whether you're just scratching the post or purring contently in the lap of luxury, RiskyPaws is here to guide you through the meandering paths of financial wisdom. Start the journey, and let's make every one of your nine lives as financially secure as they are adventurous. And remember, just like the interactive slider above think of RiskyPaws as your map to a lifetime of calculated risks and purr-fect rewards. 🌍💼🐱
  </p>
 
     
  </div></div>
      </div>
  <br><br><br><br><br><br>
       
  </template>
  
  
  <script>
  export default {

  
    data() {
      return {
        lifeStages: [
          {
            key: 'stage1',
            titleKey: 'lifestage1title',
            descriptionKey: 'lifestage1description',
          },
          {
            key: 'stage2',
            titleKey: 'lifestage2title',
            descriptionKey: 'lifestage2description',
          },   {
            key: 'stage3',
            titleKey: 'lifestage3title',
            descriptionKey: 'lifestage3description',
          },   {
            key: 'stage4',
            titleKey: 'lifestage4title',
            descriptionKey: 'lifestage4description',
          },   {
            key: 'stage5',
            titleKey: 'lifestage5title',
            descriptionKey: 'lifestage5description',
          },   {
            key: 'stage6',
            titleKey: 'lifestage6title',
            descriptionKey: 'lifestage6description',
          },
        ],
      };
    },
  };
  </script>
  
  
  
  <style scoped>
  .wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  }
  .video-container {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
      padding-top: 25px;
      height: 0;
    }
  
    .video-container iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  .content-container {
  background-color: #4A148C ;  /* Light orange color */
  color: black;
  padding: 20px;
  border-radius: 20px;  /* Adjust this value to your preference */
  overflow: hidden; 
  }
  .stingy-card {
  flex: 1;  /* Take up equal width as the iframe */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white
  }
  
  .stylish-links {
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  
  .stylish-links h3 {
  color: #333;
  font-size: 1.4em;
  margin-bottom: 15px;
  }
  
  .stylish-links ul {
  list-style: none;
  padding: 0;
  }
  
  .stylish-links ul li {
  background-color: #fff;
  margin: 10px 0;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  }
  
  .stylish-links ul li a {
  color: black;
  text-decoration: none;
  font-weight: bold;
  }
  
  .stylish-links ul li:hover {
  background-color: #4A148C;
  }
  
  .stylish-links ul li:hover a {
  color: #fff;
  }
  </style>